import { ProtectedJsonAPI } from '.'

export const PersonKyc = ProtectedJsonAPI.extend(
  '/person_kycs',
  {
    sendInstructions:   endpoint => endpoint.method('put').path(({id}) => `${id}/send_instructions`)
  }
)